import { render, staticRenderFns } from "./BaseDropdownMenu.vue?vue&type=template&id=b4177d5a&scoped=true&"
import script from "./BaseDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./BaseDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdownMenu.vue?vue&type=style&index=0&id=b4177d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4177d5a",
  null
  
)

export default component.exports